document.addEventListener('DOMContentLoaded', () => {
    // 'modal-ticket.php' を含むURLの場合は処理を中断
    if (window.location.pathname.includes('modal-ticket.php')) {
        return;
    }

    const links = document.querySelectorAll('a[href*="//www.asoview.com/channel/tickets/"]');

    links.forEach(link => {
        link.classList.add('js-ticket-modal-trigger');
        link.setAttribute('href', 'javascript:void(0)');
    });
});
